/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
/**
 * TODO: Please address the newly added events in `src/components/organisms/notifications/list/line-item/message.tsx`

 * The notification page crashes if the new events are not handled gracefully.
 */
export enum EventType {
  MessageCreated = 'MessageCreated',
  UserMentionedInMessage = 'UserMentioned',
  UserMentionedInDocument = 'UserMentionedInDocument',
  UserMentionedInTask = 'UserMentionedInTask',
  MessageReactionAdded = 'MessageReactionAdded',
  MessageReplyAdded = 'MessageReplyAdded',
  TaskCreated = 'TaskCreated',
  TaskNameOrDescriptionChanged = 'TaskNameOrDescriptionChanged',
  TaskPrivateNoteChanged = 'TaskPrivateNoteChanged',
  TaskAtRiskChanged = 'TaskAtRiskChanged',
  TaskStatusChanged = 'TaskStatusChanged',
  TaskAssignedToUser = 'TaskAssignedToUser',
  TaskAssigneeChanged = 'TaskAssigneeChanged',
  TaskFormResponseChanged = 'TaskFormResponseChanged',
  DependentTaskChanged = 'DependentTaskChanged',
  TaskPriorityChanged = 'TaskPriorityChanged',
  TaskEstimateChanged = 'TaskEstimateChanged',
  TaskAttachmentChanged = 'TaskAttachmentChanged',
  TaskFollowerAdded = 'TaskFollowerAdded',
  TaskFieldChanged = 'TaskFieldChanged',
  TaskDependencyStatusChanged = 'TaskDependencyStatusChanged',
  TaskPhaseChanged = 'TaskPhaseChanged',
  DocumentCreated = 'DocumentCreated',
  DocumentChanged = 'DocumentChanged',
  MeetingNoteCreated = 'MeetingNoteCreated',
  MeetingNoteChanged = 'MeetingNoteChanged',
  TaskStartDateChanged = 'TaskStartDateChanged',
  TaskDueDateChanged = 'TaskDueDateChanged',
  TaskDueDateOverdue = 'TaskDueDateOverdue',
  TaskStartDateReminder = 'TaskStartDateReminder',
  TaskDueDateReminder = 'TaskDueDateReminder',
  ProjectNameChanged = 'ProjectNameChanged',
  ProjectStatusChanged = 'ProjectStatusChanged',
  ProjectStartDateChanged = 'ProjectStartDateChanged',
  ProjectDueDateChanged = 'ProjectDueDateChanged',
  ProjectPhaseAdded = 'ProjectPhaseAdded',
  ProjectPhaseRemoved = 'ProjectPhaseRemoved',
  ProjectPhaseNameChanged = 'ProjectPhaseNameChanged',
  ProjectPhaseStatusChanged = 'ProjectPhaseStatusChanged',
  ProjectPhaseStartDateChanged = 'ProjectPhaseStartDateChanged',
  ProjectPhaseDueDateChanged = 'ProjectPhaseDueDateChanged',
  ProjectCsatAdded = 'ProjectCSATAdded',
  ProjectStatusUpdatePublished = 'ProjectStatusUpdatePublished',
  ProjectMemberAdded = 'ProjectMemberJoinedMyProject',
  ProjectMemberRemoved = 'ProjectMemberLeftMyProject',
  ProjectConversationMemberAdded = 'ProjectConversationMemberAdded',
  ProjectConversationMemberInvited = 'ProjectConversationMemberInvited',
  ProjectDeleted = 'ProjectDeleted',
  ProjectArchived = 'ProjectArchived',
  ProjectUnarchived = 'ProjectUnarchived',
  UserAddedToProject = 'ProjectMemberAddedToAnotherProject',
  ApprovalRequested = 'ApprovalRequested',
  ApprovalRequestChangesRequested = 'ApprovalRequestChangesRequested',
  ApprovalRequestApproved = 'ApprovalRequestApproved',
  TimesheetDueReminder = 'TimesheetDueReminder',
  TimesheetOverdueReminder = 'TimesheetOverdueReminder',
  TimesheetSubmitted = 'TimesheetSubmitted',
  TimesheetRequested = 'TimesheetRequested',
  TimesheetApproved = 'TimesheetApproved',
  TimesheetRejected = 'TimesheetRejected',
  ProjectFolderAttachmentAdded = 'ProjectFolderAttachmentAdded',
  ProjectFolderAttachmentRemoved = 'ProjectFolderAttachmentRemoved',
  ProjectFolderAttachmentChanged = 'ProjectFolderAttachmentChanged',
  MessageCreatedInTask = 'MessageCreatedInTask',
  MessageCreatedInDocumentSpaceTab = 'MessageCreatedInDocumentSpaceTab',
  MessageCreatedInDocumentStatusUpdate = 'MessageCreatedInDocumentStatusUpdate',
  MessageCreatedInProjectConversation = 'MessageCreatedInProjectConversation',
  ProjectFieldUpdated = 'ProjectFieldUpdated',
  TaskRequestApproval = 'TaskRequestApproval',
  ProjectSpaceCreated = 'ProjectSpaceCreated',
  ProjectDocumentAdded = 'ProjectDocumentAdded',
  ProjectDocumentApprovalRequests = 'ProjectDocumentApprovalRequests',
  ProjectDocumentComments = 'ProjectDocumentComments',
  StartDateReminders = 'StartDateReminders',
  DueDateReminders = 'DueDateReminders',
  DigestTask = 'DigestTask',
  DigestWeekly = 'DigestWeekly',
  TaskAnyFieldExceptStatusChanged = 'TaskAnyFieldExceptStatusChanged',
  TaskProgressChanged = 'TaskProgressChanged',
  ProjectMemberChanged = 'ProjectMemberChanged',
  ProjectMemberJoinedMyProject = 'ProjectMemberJoinedMyProject',
  ProjectMemberLeftMyProject = 'ProjectMemberLeftMyProject',
  ProjectAnyFieldChanged = 'ProjectAnyFieldChanged',
  ProjectStartDateOrDueDateChanged = 'ProjectStartDateOrDueDateChanged',
  ProjectCSATAdded = 'ProjectCSATAdded',
  ProjectPhaseStartDateOrDueDateChanged = 'ProjectPhaseStartDateOrDueDateChanged',
  DigestTaskDueDateReminder = 'DigestTaskDueDateReminder',
  DigestTaskStartDateReminder = 'DigestTaskStartDateReminder',
  DigestTaskWeekly = 'DigestTaskWeekly',
  AllApprovalEvents = 'AllApprovalEvents',
  TimeOffCreated = 'TimeOffCreated',
  TimeOffDeleted = 'TimeOffDeleted',
  ProjectPhaseUpdates = 'ProjectPhaseUpdates',
  ProjectBudgetThresholdReached = 'ProjectBudgetThresholdReached',
  ProjectHoursThresholdReached = 'ProjectHoursThresholdReached',
  ProjectPartnerAddition = 'ProjectPartnerAddition',
  ProjectPlaceholderResolve = 'ProjectPlaceholderResolve',
  NotifyThroughAutomation = 'NotifyThroughAutomation',
  NoteAdded = 'NoteAdded',
  NoteUpdated = 'NoteUpdated',
  ResourceRequestApproved = 'ResourceRequestApproved',
  ResourceRequestAssigneeChanged = 'ResourceRequestAssigneeChanged',
  ResourceRequestAssigneeUpdated = 'ResourceRequestAssigneeUpdated',
  ResourceRequestSetAssignee = 'ResourceRequestSetAssignee',
  ResourceRequestStatusChanged = 'ResourceRequestStatusChanged',
  InvoiceCreated = 'InvoiceCreated',
  InvoiceStatusChanged = 'InvoiceStatusChanged',
  InvoicePaymentAdded = 'InvoicePaymentAdded',
  InvoicePaymentRemoved = 'InvoicePaymentRemoved',
  InvoicePaymentWrittenOff = 'InvoicePaymentWrittenOff',
  InvoiceWrittenOffPaymentRemoved = 'InvoiceWrittenOffPaymentRemoved',
  InvoiceDeleted = 'InvoiceDeleted',
  ApprovalWorkFlowRequestedOnInvoice = 'ApprovalWorkFlowRequestedOnInvoice',
  ApprovalWorkFlowStatusChangedOnInvoice = 'ApprovalWorkFlowStatusChangedOnInvoice',
  ApprovalWorkFlowDueRemainderOnInvoice = 'ApprovalWorkFlowDueRemainderOnInvoice',
  ApprovalWorkFlowOverDueRemainderOnInvoice = 'ApprovalWorkFlowOverDueRemainderOnInvoice',
  BillingEventReminder = 'BillingEventReminder',
  ExpenseSubmitted = 'ExpenseSubmitted',
  ExpenseApproved = 'ExpenseApproved',
  ExpenseRejected = 'ExpenseRejected',
}
